$('.imagetip__button-content').on('click', function (event) {
  event.preventDefault();
  $($(this).data('imagetip-id')).show();
});
$('.imagetip__button--close').on('click', function (event) {
  event.preventDefault();
  $(this).parent().hide();
});
